<p-dialog
  [header]="header"
  [(visible)]="visible"
  [modal]="true"
  [style]="{ width: '700px' }"
  [closable]="true"
  (onHide)="onHide()"
  [draggable]="false"
  [resizable]="false"
>
  <div *ngIf="email" class="email-compose">
    <div class="form-group">
      <label>To</label>
      <input
        type="email"
        class="form-control"
        [(ngModel)]="email.to"
        placeholder="recipient@example.com"
      />
    </div>
    <div class="form-group mt-2" *ngIf="email.cc">
      <label>CC</label>
      <input type="text" class="form-control" [value]="email.cc" disabled />
    </div>
    <div class="form-group mt-2">
      <label>Subject</label>
      <input type="text" class="form-control" [(ngModel)]="email.subject" />
    </div>
    <div class="form-group mt-2">
      <label>Body</label>
      <div class="body-preview" [innerHTML]="email.body"></div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button class="btn btn-secondary" (click)="close()">Cancel</button>
    <button class="btn btn-primary ml-2" (click)="onConfirm()" [disabled]="!email?.to">
      <i class="fa fa-paper-plane mr-1"></i> Send
    </button>
  </ng-template>
</p-dialog>
